var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAurora = function SvgAurora(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 44 44"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aurora_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "#5DEB5A",
    rx: 22
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M21.94 11.16c1.018 0 1.933.565 2.388 1.475l7.506 15.013a2.65 2.65 0 0 1-.116 2.598 2.65 2.65 0 0 1-2.27 1.266H14.433c-.932 0-1.78-.474-2.27-1.267a2.65 2.65 0 0 1-.117-2.597l7.506-15.013a2.66 2.66 0 0 1 2.387-1.476Zm0-1.836a4.5 4.5 0 0 0-4.028 2.49l-7.507 15.014a4.504 4.504 0 0 0 4.029 6.518h15.014a4.503 4.503 0 0 0 4.028-6.518L25.97 11.814a4.5 4.5 0 0 0-4.029-2.49Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "aurora_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "#fff",
    rx: 22
  })))));
};
export default SvgAurora;